import { Component, computed, inject, Signal } from '@angular/core';
import { CdkMenu } from '@angular/cdk/menu';
import { TranslateModule } from '@ngx-translate/core';
import {
  LOCKED_END_COLUMN,
  LOCKED_START_COLUMN,
  TableColumnsService,
} from '../../../services/table-columns.service';

type ColumnVisibilityItem = { column: string; visible: boolean; locked: boolean };

@Component({
  selector: 'app-column-visibility-menu',
  imports: [TranslateModule],
  hostDirectives: [CdkMenu],
  template: `
    <section class="filter-content">
      <div class="filter-content-header">
        <p>{{ 'table.columns_menu.selection' | translate }}</p>
        @if (hasHiddenColumns()) {
          <button
            type="button"
            (click)="tableColumnsService.resetHiddenColumns(); $event.stopPropagation()"
          >
            {{ 'table.columns_menu.reset' | translate }}
          </button>
        }
      </div>
      @for (item of items(); track item.column) {
        <label class="column-option" [class.locked]="item.locked">
          <input
            #checkbox
            type="checkbox"
            [checked]="item.visible"
            [disabled]="item.locked"
            (change)="tableColumnsService.setColumnVisibility(item.column, checkbox.checked)"
          />
          {{ 'table.columns.' + item.column | translate }}
        </label>
      }
    </section>
  `,
  styleUrls: ['../filter-menu/filter-menu.scss', './column-visibility-menu.scss'],
})
export class ColumnVisibilityMenu {
  readonly tableColumnsService: TableColumnsService = inject(TableColumnsService);

  readonly hasHiddenColumns: Signal<boolean> = computed(
    () => this.tableColumnsService.hiddenColumns().length > 0,
  );

  readonly items: Signal<ColumnVisibilityItem[]> = computed(() => [
    { column: LOCKED_START_COLUMN, visible: true, locked: true },
    ...this.tableColumnsService.columns().map((column: string) => ({
      column,
      visible: !this.tableColumnsService.hiddenColumns().includes(column),
      locked: false,
    })),
    { column: LOCKED_END_COLUMN, visible: true, locked: true },
  ]);
}
